import React from "react";
import styles from "../Footer/Footer.module.css";
import footer_logo from "../../assets/images/footer_logo.png";
import instagram_icon from "../../assets/images/icons/instagram.svg";
import { useNavigate } from "react-router-dom";
const Footer = () => {
  const navigate = useNavigate();
  return (
    <div className={`${styles.footer}`}>
      <div>
        <div className={`${styles.footer_heading}`}>
          <div className={`${styles.footer_heading_top}`}>
            <div
              onClick={() => {
                navigate("/commercialtransactions");
              }}
              className={`${styles.footer_heading_top_text}`}
            >
              特定商取引法に基づく表記
            </div>
            <div
              onClick={() => {
                navigate("/privacypolicy");
              }}
              className={`${styles.footer_heading_top_text}`}
            >
              個人情報の取り扱いについて
            </div>
            <div
              onClick={() => {
                navigate("/operating-company");
              }}
              className={`${styles.footer_heading_top_text}`}
            >
              運営会社
            </div>
            <div
              onClick={() => {
                navigate("/contact-form");
              }}
              className={`${styles.footer_heading_top_text}`}
            >
              お問い合わせ
            </div>
            <div
              onClick={() => {
                window.open("https://acestudio-resv.com/", "_blank");
              }}
              className={`${styles.footer_heading_top_text}`}
            >
              撮影のご予約
            </div>
            <div
              onClick={() => {
                window.open(
                  "https://www.instagram.com/acestudio.fukuoka/",
                  "_blank"
                );
              }}
              className={`${styles.footer_heading_top_text}`}
            >
              <img
                style={{ height: "15px", width: "15px" }}
                alt="insta"
                src={instagram_icon}
              />
            </div>
          </div>
        </div>
        <div
          onClick={() => {
            window.open("https://acestudio.jp/", "_blank");
          }}
          className={styles.footer_image}
        >
          <img src={footer_logo} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Footer;
